<template>
  <article class="d-flex align-items-center">

    <h3 class="h6 font-weight-bold" v-html="name" />

    <b-button-group
        v-if="$gate.allow('update', item)"
        class="ml-auto"
    >
      <b-button
          v-if="$gate.allow('update', item)"
          :disabled="item.busy"
          :title="$t('Edit {0}', [item.name])"
          :to="{name: 'projects.services.show', params: {projectId: item.project_id, id: item.id}}"
          variant="primary"
      >
        <fa
            :spin="item.busy"
            icon="edit"
        />
      </b-button>

      <b-button
          :disabled="item.busy"
          :title="$t('Delete')"
          variant="danger"
          @click="handleDelete"
      >
        <fa
            :spin="item.busy"
            :title="$t('Delete')"
            icon="trash"
        />
      </b-button>
    </b-button-group>
  </article>
</template>

<script>
import Form from 'vform';
import IssueButton from "@/components/issues/IssueButton";
import itemMixin from "@/mixins/itemMixin";

export default {
  name: 'ServiceListItem',
  components: {IssueButton},
  mixins: [itemMixin],
  props: {
    hideCoveredCheckbox: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      lazy: true,
      item: new Form(this.value),
      showEditModal: false,
    }
  },
  computed: {
    itemUrl() {
      return `/api/projects/${this.projectId}/available_services/${this.value.id}`;
    },

    projectId() {
      return this.value.project_id;
    },

    resourceName() {
      return `projects/${this.projectId}/available_services`
    },

    deleteApiUrl() {
      return this.itemUrl;
    },

    name() {
      return this.value.formatted_string;
    },
  },
  watch: {
    value(newValue) {
      this.item = new Form(newValue);
    }
  },

  methods: {
    afterDelete() {

    }
  }
};
</script>
